export class DistributorParams {
    Rol: string[] = [];    
    Dr: string[] = [];    
    PvGroup: string[] = [];    
    Distributor: string[] = [];
    Taller: string[] = [];
  }